import { useQuery } from 'react-query';
import { backend } from '../axios/backend';
import { Product } from '../types/product';

export const useWish = (id?: string) =>
  useQuery(['wish', id], async () => (await backend.get<Product>(`wish/my/${id}`)).data, {
    enabled: !!id,
  });
